// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","964":"product"}[chunkId] + "." + {"594":"3b28ba7f","964":"ff598976"}[chunkId] + ".js";
};